import React, { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import ContentLayer from '#/components/ContentLayer/ContentLayer';
import { loadContainers } from '#/redux/modules/brightcove/actions';
import { getCurrentProfileAgeGroup } from '#/redux/modules/onboarding/selectors';
import {
  getCustomDataVideosBlocked,
  getCustomDataShowsBlocked,
} from '#/redux/modules/identity/selectors';
import { toggleSpinner } from '#/redux/modules/spinner/actions';
import { isWorkstation } from '#/utils/componentStyleConfig';
import {
  ageGroupsKeys,
  containersAgeGroup,
  containersTypeAlias,
  SWIMLANE_LENGTH,
  INITIAL_SWIMLANE_COUNT,
} from '#/config/constants';

const Home = ({ content, history, entries }) => {
  const currentPath = history.location.pathname.split('/').slice(-1)[0];
  const dispatch = useDispatch();
  const customDataShowsBlocked = useSelector(getCustomDataShowsBlocked);
  const customDataVideosBlocked = useSelector(getCustomDataVideosBlocked);
  const selectedAgeGroup = useSelector(state =>
    getCurrentProfileAgeGroup(state),
  );

  const selectedContainers = useMemo(() => {
    switch (selectedAgeGroup) {
      case ageGroupsKeys.TWO_UP:
        return containersAgeGroup.CONTAINER_2Up;
      case ageGroupsKeys.FIVE_UP:
        return containersAgeGroup.CONTAINER_5Up;
      default:
        return containersAgeGroup.CONTAINER_8Up;
    }
  }, [selectedAgeGroup]);

  const getContainers = useMemo(() => {
    const limit = isWorkstation() ? 100 : SWIMLANE_LENGTH + 1;

    if (Object.keys(content).length > 0) {
      const containers = [];
      content?.[currentPath]?.[selectedContainers]?.forEach(item => {
        const menuItem = entries?.[item];
        if (menuItem) {
          containers.push(menuItem);
        }
      });

      dispatch(
        loadContainers({
          queries: containers
            .filter(
              container =>
                container._meta.typeAlias ===
                containersTypeAlias.CONTAINER_OVP_PLAYLIST,
            )
            .slice(0, Math.min(containers.length, INITIAL_SWIMLANE_COUNT))
            .map(container => ({
              playlistId: container.playlistId,
              containerId: container._meta.id,
              limit: container.pageLimitPerPlatform + 1 ?? limit,
            })),
        }),
      );

      return containers;
    }
    return null;
  }, [content, customDataShowsBlocked, customDataVideosBlocked]);

  useEffect(() => {
    if (content) {
      requestAnimationFrame(() => {
        dispatch(toggleSpinner(false));
      });
    }
  }, []);

  return (
    <>
      {Object.keys(content).length > 0 ? (
        <ContentLayer
          initialContainers={getContainers}
          initialContainersSize={INITIAL_SWIMLANE_COUNT}
        />
      ) : null}
    </>
  );
};

Home.propTypes = {
  content: PropTypes.object,
  history: PropTypes.object,
  entries: PropTypes.object,
};

export default Home;
